import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { interceptRouterName } from './utils'
import { useStorage } from './hooks/web/useStorage'
import { commonEnums } from './enumerations'

const { start, done } = useNProgress()
const { removeStorage } = useStorage()
const { loadStart, loadDone } = usePageLoading()

router.beforeEach(async (to, from, next) => {
  const toPath = interceptRouterName(to.fullPath)
  const fromPath = interceptRouterName(from.fullPath)

  if (toPath !== fromPath) {
    removeStorage(fromPath)
  }

  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  if (userStore.getUserInfo) {
    // 开发者可根据实际情况进行修改
    const roleRouters: any = userStore.getRoleRouters || []

    if (to.path === '/login') {
      let path = '/'
      if (roleRouters) {
        path = roleRouters[0].url
      }

      next({ path })
    } else {
      if (permissionStore.getIsAddRouters) {
        if (
          from.name == 'FirstPersonRecommended' &&
          userStore.fellowInfo?.declarationRequired == commonEnums.TrueOrFalse.True
        ) {
          next({ name: 'FirstPersonRecommended' })
          return
        }

        next()
        return
      }

      // 是否使用动态路由
      if (appStore.getDynamicRouter) {
        appStore.serverDynamicRouter
          ? await permissionStore.generateRoutes('server', roleRouters as AppCustomRouteRecordRaw[])
          : await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
      } else {
        await permissionStore.generateRoutes('static')
      }

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)
      next(nextData)
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      let path = `/login?redirect=${to.path}?`
      if (to.query) {
        Object.keys(to.query).forEach((key) => {
          path += `${key}=${to.query[key]}&`
        })
        path = path.substring(0, path.length - 1)
      }

      next(path) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
